/**
 * @file コンポーネント：ボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton, StyledButtonIcon, StyledButtonText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledButton
            className={[
                props.disabled === true && "is-disabled",
                props.dummyDisabled === true && "is-dummy-disabled",
                props.isFullHeight === true && "is-fullheight",
                props.isWide === true && "is-wide",
            ]}
            data-button-type={props.buttonType}
            data-font-size={props.fontSize}
            href={props.href}
            id={props.id}
            onClick={props.onClick}
            target={props.target}
            title={props.title}
        >
            <>
                {props.icon && (
                    <StyledButtonIcon data-font-weight={props.fontWeightIcon}>
                        {props.icon}
                    </StyledButtonIcon>
                )}
                <StyledButtonText>{props.text}</StyledButtonText>
            </>
        </StyledButton>
    );
};
